import React, { Component } from 'react'
import { FormControl, Autocomplete, TextField } from '@mui/material'
import { FormInputLabel } from '@/shared/ui/input'

class NivoSchemeSelector extends Component {
    getOptions() {
        return [
            'nivo',
            // categorical
            'category10',
            'accent',
            'dark2',
            'paired',
            'pastel1',
            'pastel2',
            'set1',
            'set2',
            'set3',
            // diverging
            'brown_blueGreen',
            'purpleRed_green',
            'pink_yellowGreen',
            'purple_orange',
            'red_blue',
            'red_grey',
            'red_yellow_blue',
            'red_yellow_green',
            'spectral',
            // sequential single hue
            'blues',
            'greens',
            'greys',
            'oranges',
            'purples',
            'reds',
            // sequential multi hue
            'blue_green',
            'blue_purple',
            'green_blue',
            'orange_red',
            'purple_blue_green',
            'purple_blue',
            'purple_red',
            'red_purple',
            'yellow_green_blue',
            'yellow_green',
            'yellow_orange_brown',
            'yellow_orange_red',
        ]
    }

    handleChange(_event, option) {
        if (!this.props.onChange) {
            return
        }
        this.props.onChange({
            target: { value: option?.value ?? '' },
        })
    }

    render() {
        const kedo = this.props.kedo
        const chooseLabel = kedo.t('Choose an option')
        const emptyOption = { value: '', label: chooseLabel }
        const options = [
            emptyOption,
            ...this.getOptions().map((scheme) => ({
                value: scheme,
                label: scheme,
            })),
        ]
        const rawValue =
            typeof this.props.value === 'string' ? this.props.value : ''
        const value =
            options.find((option) => option.value === rawValue) || emptyOption

        return (
            <div>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{kedo.t('Color scheme')}</FormInputLabel>
                    <Autocomplete
                        size="small"
                        options={options}
                        value={value}
                        onChange={this.handleChange.bind(this)}
                        getOptionLabel={(option) => option?.label || ''}
                        isOptionEqualToValue={(option, selected) =>
                            option.value === selected.value
                        }
                        disableClearable
                        renderInput={(params) => (
                            <TextField {...params} size="small" />
                        )}
                    />
                </FormControl>
            </div>
        )
    }
}

export default NivoSchemeSelector
